import { z } from "zod";
import { BasePubSubEvent } from "../pubsub";

// these constants exist to satisfy pubsub requirements for a realm and channel
export const RealmName = "realtime_media" as const;
export const ChannelName = "realtime_media_channel" as const;

export type AIAnalysisOutput<T=string> = {
  field: string,
  conversationId: string,
  value: T,
}

export type QueuedJobOutput = {
  jobId: string,
  field?: string
}

export const docAssistanceResultSchema = z.object({
  field: z.string(),
  conversationId: z.string(),
  value: z.string().optional(),
  imageUrl: z.string().optional(),
  error: z.string().optional()
});

export type DocAssistanceResult = z.infer<typeof docAssistanceResultSchema>

export type SubscribeEvent = BasePubSubEvent<
  "subscribe",
  {
    jobId: string
  }
>

export type DidSubscribeEvent = BasePubSubEvent<
  "didSubscribe",
  {
    jobId: string,
    result: Partial<DocAssistanceResult>
  }
>

export type AsyncMediaUpdateEvent = BasePubSubEvent<
  "asyncMediaUpdate",
  {
    jobId: string,
    result: Partial<DocAssistanceResult>
  }
>
